export enum ClaimElementName {
    DamageDate = 'damage_date',
    DamageTime = 'damage_event_time',
}
